/* Healthy Box — attributs de commande.
   Un attribut de panier suit la commande jusque dans l'admin, a cote de
   l'adresse. On s'en sert pour le jour de livraison souhaite.
   Separe de healthy-box-box.js : aucune page n'a besoin des deux. */
(function(){
  'use strict';

  var HB = window.HealthyBox = window.HealthyBox || {};

  /* Ecrit un attribut sur le panier. Une chaine vide l'efface. */
  HB.definirAttribut = function(nom, valeur){
    var attrs = {};
    attrs[nom] = (valeur === null || valeur === undefined) ? '' : String(valeur);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(r){ return r.json(); })
      .catch(function(){ return null; });
  };

  HB.lireAttributs = function(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ return (c && c.attributes) || {}; })
      .catch(function(){ return {}; });
  };
})();
